"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    animation: Boolean | Object,
    autoBind: Boolean,
    autoScroll: Boolean,
    checkboxes: Boolean | Object,
    dataImageUrlField: String,
    dataSource: Object | Array,
    dataSpriteCssClassField: String,
    dataTextField: String | Array,
    dataUrlField: String,
    dragAndDrop: Boolean,
    loadOnDemand: Boolean,
    messages: Object,
    template: String | Function,

    // Events
    change: Function,
    check: Function,
    collapse: Function,
    dataBound: Function,
    drag: Function,
    dragend: Function,
    dragstart: Function,
    drop: Function,
    expand: Function,
    navigate: Function,
    select: Function
};